'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (palette) {
    return {
        background: palette.elPrimary,
        borderColor: palette.elPrimary,
        color: palette.tFilled,
        boxShadow: '0 6px 10px 0 ' + palette.elShadow + ', 0 4px 10px 0 ' + palette.elShadow,
        zIndex: palette.zOverlay,
        headFontSize: palette.tsNormal,
        headLineHeight: palette.tlNormal,
        monthDecreaseIcon: _arrow_left2.default,
        monthIncreaseIcon: _arrow_right2.default,
        dateColor: palette.tFilled,
        dateFontSize: palette.tsSmall,
        dateLineHeight: palette.tlSmall,
        dateBackground: 'transparent',

        dateColorHover: palette.tActive,
        dateBackgroundHover: palette.elLightest,

        dateColorActive: palette.tInversion,
        dateBackgroundActive: palette.elAccent,

        dateTodayColor: palette.tAccent,
        dateTodayBackground: 'transparent',

        dateDisabledColor: palette.tDisabled,
        dateDisabledBackground: 'transparent',

        dateSelectedColor: palette.tInversion,
        dateSelectedBackground: palette.elAccent,

        periodBackground: (0, _color2.default)(palette.elAccent).alpha(0.25).string()
    };
};

var _arrow_left = require('../img/arrow_left.svg');

var _arrow_left2 = _interopRequireDefault(_arrow_left);

var _arrow_right = require('../img/arrow_right.svg');

var _arrow_right2 = _interopRequireDefault(_arrow_right);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }